<script setup lang="ts">
import FreemiumSignupForm from "@/components/signups/FreemiumSignupForm.vue"
</script>

<template>
    <div class="hero max-w-screen-lg mx-auto lg:mt-[10vh]">
        <div class="hero-content flex-col lg:flex-row lg:items-start gap-16">
            <div class="pt-5 text-center lg:text-left">
                <h1 class="text-5xl font-light">Sign up for <span class="text-primary italic font-medium">financial freedom</span>.</h1>
                <p class="text-xl pt-6">Sign up to gain access to our free services, receive weekly commentary, analysis, and investment education without any cost or obligation.</p>
            </div>
            <div class="flex-shrink-0 w-full max-w-md card py-8 px-6">
                <FreemiumSignupForm />
            </div>
        </div>
    </div>
</template>